// src/data/useCreateWork.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import ExhibitionService from "../service/ExhibitionService";
import { useNotification } from "../context/NotificationContext";

export function useCreateExhibition() {
  const queryClient = useQueryClient();
  const { addNotification } = useNotification();

  const { mutate: createExhibition, isLoading: isCreating } = useMutation({
    mutationFn: async (newExhibition) => {
      try {
        const response = await ExhibitionService.create(newExhibition);
        console.log("API Response:", response); // Log della risposta dell'API
        return response; // Assicurati di restituire la risposta
      } catch (error) {
        console.error("API Error:", error); // Log degli errori
        throw error; // Rilancia l'errore per la gestione
      }
    },
    onSuccess: async (data) => {
      //Aggiorna i dati restuiti dal server nel localStorage locale
      const savedData =
        JSON.parse(localStorage.getItem("exhibitionsData")) || [];
      const updatedData = [...savedData, data];

      localStorage.setItem("exhibitionsData", JSON.stringify(updatedData));
      // Invalida e refetch dei dati
      queryClient.invalidateQueries(["exhibitions"]);
    },

    onError: (error) => {
      // Gestisci l'errore
      addNotification(error.message, "error");
      console.error("Error adding exhibition:", error);
    },
  });

  return { isCreating, createExhibition };
}
